<template>
  <div>
    <v-footer height="auto">
      <v-layout justify-center row wrap>
        <v-flex pt-2 black--text xs10 style="background-color: #FAFAFA">
          <!--v-img :src="appname.imgFooter"  class="mx-auto" /-->
        </v-flex>
        <v-flex text-xs-center black--text xs12 white>
          <LinksUtiles :cliente_id="cliente_id"></LinksUtiles>
        </v-flex>
        <v-flex grey darken-2 pa-2 text-xs-center white--text xs12>
          <v-layout justify-center row wrap>
            <v-flex grey darken-2 pt-2 text-xs-center white--text xs2>
              <a href="http://qr.afip.gob.ar/?qr=Orlqu2ODPGA4bf9ykr2Gow,," target="_F960AFIPInfo" class="float-left"
                ><img
                  src="https://www.allseasons.tur.ar/ws/utiles/img/afip.jpg"
                  border="0"
                  class="img-fluid img-data-fiscal"
              /></a>
              <img
                src="https://www.shoppingviajes.com/images/galeria/operadorSelecto.jpg"
                border="0"
                style="width: 100px;"
              />
              <img
                src="https://www.allseasons.tur.ar/ws/utiles/img/mintur-allseaso.jpg"
                alt=""
                class="img-responsive qr-as float-right"
              />
            </v-flex>
            <v-flex grey darken-2 pt-2 pl-4 text-xs-justify white--text xs8>
              <p class="caption font-weight-light mb-3">
                All Seasons S.R.L - Leg. 4470 Res. 0427/85. - Esmeralda 740 1º piso, (C1007ABH), Buenos Aires,
                Argentina.Tel.: (54 11) 5263-3434 Fax: (54 11) 4322 7724, info@allseasons.com.ar| C.U.I.T 30-61284483-2.
              </p>
              <p class="caption font-weight-light mb-3">
                Sitio web de navegación exclusiva para agentes de viajes.
              </p>
              <p class="caption font-weight-light mb-0">
                Tarifas finales, expresadas por persona en usd dolares y en pesos argentinos, segun se indique,
                equivalentes a pesos al tipo de cambio de la fecha del pago.
              </p>
              <p class="caption font-weight-light mb-0">
                Pagos en efectivo y depósito bancario: de acuerdo a la RG AFIP 3819/3825 aplica 5% adicional de
                percepción a cuenta de bienes personales e impuesto a las ganancias. transferencias bancarias y tarjetas
                de crédito: no se encuentran alcanzadas por la percepción mencionada. Impuesto pais 30% ley 27.541:
                pagos en usd dólares no aplica. para pagos en ars pesos se incuentra discriminado e incluído en las
                tarifas.
              </p>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex grey darken-3 pa-2 text-xs-center white--text xs12>
          <v-layout justify-center row wrap>
            <v-flex grey darken-3 text-xs-justify white--text xs2>
              <img
                id="trustwaveSealImage"
                src="https://sealserver.trustwave.com/seal_image.php?customerId=d5a2819d766845f4911efbebb792c22b&size=105x54&style=invert"
                border="0"
                style="cursor:pointer;"
                onclick="javascript:window.open('https://sealserver.trustwave.com/cert.php?customerId=d5a2819d766845f4911efbebb792c22b&size=105x54&style=invert&baseURL=', 'c_TW', 'location=no, toolbar=no, resizable=yes, scrollbars=yes, directories=no, status=no, width=615, height=720'); return false;"
                oncontextmenu="javascript:alert('Copying Prohibited by Law - Trusted Commerce is a Service Mark of TrustWave Holdings, Inc.'); return false;"
                alt="This site is protected by Trustwave's Trusted Commerce program"
                title="This site is protected by Trustwave's Trusted Commerce program"
              />
              <img
                src="https://www.allseasons.com.ar/images/galeria/pci_dss_compliance.png"
                alt=""
                class="img-responsive float-right"
                style="width: 90px;"
              />
            </v-flex>
            <v-flex grey darken-3 text-xs-justify white--text xs8>
              <p class="caption font-weight-light ">
                Dirección General de Defensa y Protección al Consumidor - Consultas y/o denuncias. El titular de los
                datos personales tiene la facultad de ejercer el derecho de acceso a los mismos en forma gratuita a
                intervalos no inferiores a seis meses, salvo que se acredite un interés legítimo al efecto conforme lo
                establecido en el artículo 14, inciso 3 de la Ley Nº 25.326". "La DIRECCION NACIONAL DE PROTECCION DE
                DATOS PERSONALES, Organo de Control de la Ley Nº 25.326, tiene la atribución de atender las denuncias y
                reclamos que se interpongan con relación al incumplimiento de las normas sobre protección de datos
                personales.
              </p>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex grey darken-4 pa-2 text-xs-center white--text xs12>
          <v-layout justify-center row wrap>
            <v-flex grey darken-4 text-xs-center white--text xs12>
              <p class="caption font-weight-bold mb-0 ">
                ALL SEASONS © 2017 | Todos los derechos reservados
              </p>
            </v-flex>
            <v-flex grey darken-4 text-xs-center white--text xs12>
              <v-btn icon>
                <v-icon
                  color="white"
                  dark
                  small
                  class="cur-pointer"
                  @click="_$goToUrl('https://www.facebook.com/AllSeasonsViajesyTurismo/')"
                  >fab fa-facebook</v-icon
                >
              </v-btn>
              <v-btn icon>
                <v-icon
                  color="white"
                  dark
                  small
                  class="cur-pointer"
                  @click="_$goToUrl('https://comunidad.allseasons.com.ar/')"
                  >fab fa-twitter</v-icon
                >
              </v-btn>
              <v-btn icon>
                <v-icon
                  color="white"
                  dark
                  small
                  class="cur-pointer"
                  @click="_$goToUrl('https://www.youtube.com/channel/UCx4BNnKLdF6tg44HsDmdA8g')"
                  >fab fa-youtube</v-icon
                >
              </v-btn>
              <v-btn icon>
                <v-icon
                  color="white"
                  dark
                  small
                  class="cur-pointer"
                  @click="_$goToUrl('https://www.instagram.com/allseasons_turismo/')"
                  >fab fa-instagram</v-icon
                >
              </v-btn>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-footer>
  </div>
</template>

<script>
import { VclList } from "vue-content-loading"
import { mapGetters } from "vuex"
import LinksUtiles from "@/components/utiles/LinksUtiles.vue"
export default {
  props: ["footerImg"],
  mounted() {},
  methods: {},
  components: {
    VclList,
    LinksUtiles
  },
  computed: {
    ...mapGetters("app", {
      appname: "getApp"
    })
  },
  watch: {
    appname: {
      immediate: true,
      deep: true,
      handler(newVal, oldVal) {
        this.cliente_id = newVal.cliente_id
      }
    }
  },
  data() {
    return {
      cliente_id: 0
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bg-redes-sociales {
  background-color: black;
}
.title-utiles-links-as {
  font-size: 11px;
}
.utiles-links-as {
  font-size: 12px;
}
.img-data-fiscal {
  width: 52px;
}
.qr-as {
  width: 72px;
}
.bk-footer {
  background-color: #d1d1d1;
}
</style>
